import React from 'react'
import { Image } from 'semantic-ui-react'


const ImageExampleGroupSize = () => (
  <React.Fragment>
    <Image.Group size='tiny'>
      <Image  src='https://cdn.iconscout.com/icon/free/png-512/ruby-47-1175102.png' />
      <Image  src='https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/Ruby_On_Rails_Logo.svg/1200px-Ruby_On_Rails_Logo.svg.png' />
      <Image  src='https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/512px-Unofficial_JavaScript_logo_2.svg.png' />
      <Image  src='https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSb-fKJMA2hvqzBq2zzo8uyuEMt8AjEMmF5bOIGCc8fpU5JgK-f&usqp=CAU' />
      <Image  src='https://toppng.com/uploads/preview/react-native-svg-transformer-allows-you-import-svg-aperture-science-innovators-logo-11562851994zqcpwozsvy.png' />
      <Image  src='https://upload.wikimedia.org/wikipedia/commons/4/49/Redux.png' />
      <Image  src='https://miro.medium.com/max/624/1*kuITW-HAzQSTqp40IcOziQ.png' />
      <Image  src='https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/SQLite370.svg/1280px-SQLite370.svg.png' />
      <Image  src='https://cdn.iconscout.com/icon/free/png-512/postgresql-11-1175122.png' />
      <Image  src='https://allprowebdesigns.com/blog/wp-content/uploads/2019/01/1lJ32Bl-lHWmNMUSiSq17gQ-792x445.png' />
      <Image  src='https://cdn.iconscout.com/icon/free/png-256/git-16-1175195.png' />
    </Image.Group>
  </React.Fragment>
)

export default ImageExampleGroupSize